var _defs, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoogleGLogo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.683,
    height: 16,
    viewBox: "0 0 15.683 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#4285f4;}.b{fill:#34a853;}.c{fill:#fbbc04;}.d{fill:#ea4335;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M279.784,224.726a9.406,9.406,0,0,0-.138-1.626H272.1v3.081h4.321a3.7,3.7,0,0,1-1.6,2.431v2H277.4a7.813,7.813,0,0,0,2.384-5.885Z",
    transform: "translate(-264.1 -216.541)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M36.049,330.767a7.658,7.658,0,0,0,5.3-1.931l-2.578-2A4.852,4.852,0,0,1,31.56,324.3H28.9v2.061A8,8,0,0,0,36.049,330.767Z",
    transform: "translate(-28.049 -314.767)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M3.458,155.123a4.792,4.792,0,0,1,0-3.063V150H.8a8.007,8.007,0,0,0,0,7.184Z",
    transform: "translate(0.05 -145.59)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M36.049,3.148a4.347,4.347,0,0,1,3.069,1.2L41.4,2.063A7.689,7.689,0,0,0,36.049-.018,8,8,0,0,0,28.9,4.391l2.657,2.061a4.785,4.785,0,0,1,4.491-3.3Z",
    transform: "translate(-28.049 0.018)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleGLogo);
export default __webpack_public_path__ + "static/media/Google__G__Logo.8a00a91bf7a91c410dfb1f3bcaa78c37.svg";
export { ForwardRef as ReactComponent };